<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <h2 class="titulo">ASSINATURA OBRIGATÓRIA</h2>
        <v-layout wrap class="justify-center">
            <v-flex xs12 md10>
                <div class="d-flex justify-center">
                    <h5 class="primary--text">Para prosseguir com a venda é obrigatório a assinatura do contrato digital pelo cliente</h5>
                </div>
                <div class="d-flex justify-center">
                    <h5 class="primary--text">Por favor, revise os dados da proposta e selecione o botão abaixo para geração do contrato</h5>
                </div>
                <div class="mx-1 mt-3 mb-5">
                    <dados-da-compra :pedido="pedido" :desconto="desconto" :permite-flavor-todos-produtos="false" :seguro="seguro" :aguardando-pagamento-cliente="AguardandoPagamentoCliente" />
                </div>
                <div class="mb-5">
                    <v-row class="primary--text ma-1 pointer" @click="sections.cliente = !sections.cliente">
                        <h2>Dados do cliente</h2>
                        <v-spacer />
                        <v-icon color="primary" class="mt-1" :class="{ 'rotate90': sections.cliente }">
                            chevron_right
                        </v-icon>
                    </v-row>
                    <v-divider />
                    <collapse-transition>
                        <div class="ma-1 my-3" v-show="sections.cliente">
                            <v-layout wrap>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? 'CPF' : 'CNPJ' }}</label>
                                    <p>
                                        {{ (isPessoaFisica() ? pedido.cliente.cpf : pedido.cliente.cnpj) || '-' }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? 'Nome' : 'Razão social' }}</label>
                                    <p>
                                        {{ cliente() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="!isPessoaFisica()">
                                    <label>Nome fantasia</label>
                                    <p>
                                        {{ nomeFantasia() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>
                                        {{ isPessoaFisica() ? 'Data de nascimento' : 'Data de fundação' }}
                                    </label>
                                    <p>{{ getData(pedido) }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? 'Nacionalidade' : 'Atividade' }}</label>
                                    <p>
                                        {{ nacionalidadeAtividade() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="isPessoaFisica()">
                                    <label>{{ 'Sexo' }}</label>
                                    <p>
                                        {{ sexoNomeSocio() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? 'Renda' : 'Faturamento médio' }}</label>
                                    <p>{{ getMoney(pedido) }}</p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="isPessoaFisica()">
                                    <label>Politicamente exposto</label>
                                    <p>{{ getPoliticamenteExposto() }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Telefone</label>
                                    <p>
                                        {{ getTelefone(pedido.cliente, pedido.instancia_cliente) }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Celular</label>
                                    <p>{{ getTelefoneCelular(pedido.instancia_cliente, pedido.cliente) }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>E-mail</label>
                                    <p>{{ getEmail(pedido.instancia_cliente, pedido.cliente) }}</p>
                                </v-flex>
                            </v-layout>
                        </div>
                    </collapse-transition>
                </div>
                <div class="mb-5" v-if="!isPessoaFisica()">
                    <v-row class="primary--text ma-1 pointer" @click="sections.socios = !sections.socios">
                        <h2>Dados do(s) Sócio(s)</h2>
                        <v-spacer />
                        <v-icon color="primary" class="mt-1" :class="{ 'rotate90': sections.socios }">
                            chevron_right
                        </v-icon>
                    </v-row>
                    <v-divider />
                    <collapse-transition>
                        <div class="ma-1 my-3" v-show="sections.socios">
                            <v-layout wrap>
                                <v-flex xs12 md6>
                                    <label>{{ 'Nome' }}</label>
                                    <p>
                                        {{ pedido.cliente_pedido.nome_completo }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ 'CPF' }}</label>
                                    <p>
                                        {{ pedido.cliente_pedido.cpf || '-' }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Politicamente exposto</label>
                                    <p>{{ getPoliticamenteExposto() }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Beneficiário Final</label>
                                    <p>{{ pedido.beneficiario.cpf == pedido.cliente.cpf_socio ? 'Sim' : 'Não' }}</p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                    <label>Nome do beneficiario</label>
                                    <p>{{ pedido.beneficiario.nome_completo ? pedido.beneficiario.nome_completo : pedido.cliente.nome_completo || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                    <label>CPF do beneficiario</label>
                                    <p>{{ pedido.beneficiario.cpf ? pedido.beneficiario.cpf : pedido.cliente.cpf_socio || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                    <label>Politicamente exposto?</label>
                                    <p>{{ getBeneficiarioPoliticamenteExposto() ? getBeneficiarioPoliticamenteExposto() : getPoliticamenteExposto() || '-' }}</p>
                                </v-flex>
                            </v-layout>
                        </div>
                    </collapse-transition>
                </div>
                <div class="mb-5">
                    <v-row class="primary--text ma-1 pointer" @click="sections.endereco = !sections.endereco">
                        <h2>Endereço</h2>
                        <v-spacer />
                        <v-icon color="primary" class="mt-1" :class="{ 'rotate90': sections.endereco }">
                            chevron_right
                        </v-icon>
                    </v-row>
                    <v-divider />
                    <collapse-transition>
                        <div class="ma-1 my-3" v-show="sections.endereco">
                            <v-layout wrap>
                                <v-flex xs12 md6>
                                    <label>CEP</label>
                                    <p>{{ enderecos[0] ? getCep(enderecos[0]) : '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Nome do logradouro</label>
                                    <p>{{ enderecos[0].endereco || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Número</label>
                                    <p>{{ enderecos[0].numero || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Complemento</label>
                                    <p>{{ enderecos[0].complemento || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Bairro</label>
                                    <p>{{ enderecos[0].bairro || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Cidade / Estado</label>
                                    <p>{{ enderecos[0].cidade.nome || '' }} - {{ enderecos[0].cidade.uf || '' }}</p>
                                </v-flex>
                            </v-layout>
                        </div>
                    </collapse-transition>
                </div>
                <v-layout row-padding class="justify-space-between">
                    <v-flex class="col">
                        <v-btn id="ButtonVoltar" v-if="isVendaNaoGerada(pedido.status_pedido)" block color="secondary" @click="voltar()" style="margin-left: 0;">Voltar</v-btn>
                    </v-flex>
                    <v-flex class="col">
                        <v-btn id="ButtonProsseguir" v-if="isVendaNaoGerada(pedido.status_pedido)" block color="primary"
                               @click="finalizar()" style="margin-right: 0;">
                            Gerar Contrato
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
  import { asyncAlert, notification, trimZeros, isVendaNaoGerada } from '@/plugins/helpers'
  import { FormasPagamento, OpcoesFuroDesc, PoliticamenteExposto, StatusPedido, TipoPessoa } from '@/plugins/constants'
  import { cep, money, toDateBR } from '@/plugins/formatters'
  import { mapState } from 'vuex'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import { pedido_default } from '../../../plugins/pedido_default'
  import realizarVendaMixin from '../../../mixins/realizarVendaMixin'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import DadosDaCompra from '../../../fragments/InformacoesProposta/DadosDaCompra.vue'
  import telefonesMixin from '@/mixins/telefonesMixin'
  import emailMixin from '@/mixins/emailMixin'

  export default {
    name: 'ResumoContrato',
    components: { DadosDaCompra },
    mixins: [realizarVendaMixin, telefonesMixin, emailMixin],
    props: { value: Object },
    data: () => ({
      desconto: false,
      sections: {
        cliente: true,
        endereco: true,
        socios: true
      },
      dialog_email: false,
      pedido: pedido_default,
      enderecos: [ {
        id_endereco: '',
        id_cliente: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        estado: '',
        id_cidade: '',
        principal: '',
        ativo: '',
        cidade: {
          nome: ''
        }
      } ]
    }),
    computed: {
      ...mapState(['jornada_venda']),
      OpcoesFuroDesc: () => OpcoesFuroDesc,
      StatusPedido: () => StatusPedido,
      TipoPessoa: () => TipoPessoa,
      /**
       * @return {boolean}
       */
      AguardandoPagamentoCliente () {
        return this.pedido.forma_pagamento === FormasPagamento.Link && !isVendaNaoGerada(this.pedido.status_pedido) && this.pedido.status_pedido !== StatusPedido.Cancelado && this.pedido.status_pedido !== StatusPedido.Pago && this.pedido.status_pedido !== StatusPedido.CanceladoNewcon
      },
      seguro () {
        return this.$session.get('configuracoes').seguro
      },
      nome_comissionado () {
        const comissionados = this.$session.get('comissionados')
        const comissionado = comissionados.find(c => c.ID_Comissionado === this.pedido.id_comissionado)
        let nome_comissionado = ''
        if (comissionado) {
          nome_comissionado = `${comissionado['CD_Comissionado']} - ${comissionado['NM_Pessoa']}`
        }
        return nome_comissionado
      }
    },
    watch: {

    },
    mounted () {
      if (this.value && this.value.id_pedido) {
        this.$http.get(`/vendas/${this.value.id_pedido}`)
          .then(res => {
            this.desconto = res.data.desconto
            res.data.beneficiario = { ...this.pedido.beneficiario, ...res.data.beneficiario }
            res.data.cliente_pedido = { ...this.pedido.cliente_pedido, ...res.data.cliente_pedido }
            res.data.cliente = { ...this.pedido.cliente, ...res.data.cliente }
            res.data.produto = { ...this.pedido.produto, ...res.data.produto }
            res.data.bem = { ...this.pedido.bem, ...res.data.bem }
            res.data.grupo = { ...this.pedido.grupo, ...res.data.grupo }
            res.data.plano = { ...this.pedido.plano, ...res.data.plano }
            this.pedido = { ...this.pedido, ...res.data }

            this.sendAnalytics()
            if (this.pedido.cliente.enderecos.length > 0) {
              this.enderecos = this.pedido.cliente.enderecos
            }
          })
          .catch(err => notification('error', err, 'Não foi possível buscar a venda.'))
      }
    },
    methods: {
      isPessoaFisica () {
        return this.pedido.cliente.pessoa === TipoPessoa.Fisica
      },
      isVendaNaoGerada (status) {
        return isVendaNaoGerada(status)
      },
      getTelefone () {
        return this.pedido.cliente.telefone_residencial || this.pedido.cliente.telefone_comercial || '-'
      },
      cliente () {
        return (this.isPessoaFisica() ? this.pedido.cliente.nome_completo : this.pedido.cliente_pedido.razao_social) || '-'
      },
      nacionalidadeAtividade () {
        return (this.isPessoaFisica() ? this.pedido.cliente.nacionalidade : this.pedido.cliente.atividade.nome) || '-'
      },
      sexoNomeSocio () {
        return (this.isPessoaFisica() ? _.startCase(this.pedido.cliente.genero) : '-')
      },
      nomeFantasia () {
        return this.pedido.cliente_pedido.nome_fantasia
      },
      getData (pedido) {
        let data = pedido.cliente.pessoa === TipoPessoa.Fisica ? pedido.cliente.data_nascimento : pedido.cliente_pedido.data_fundacao
        if (data) {
          return toDateBR(data)
        }
        return '-'
      },
      getMoney (pedido) {
        let renda = pedido.cliente.pessoa === TipoPessoa.Fisica ? pedido.cliente.renda : pedido.cliente.faturamento_medio
        if (renda) {
          return money(renda)
        }
        return '-'
      },
      getCep (endereco) {
        const _cep = endereco.cep
        return _cep ? cep(_cep) : '-'
      },
      getPoliticamenteExposto () {
        if (this.pedido.cliente.politicamente_exposto) {
          return this.pedido.cliente.politicamente_exposto === PoliticamenteExposto.NaoPoliticamenteExposto ? 'Não' : 'Sim'
        }
        return '-'
      },
      getBeneficiarioPoliticamenteExposto () {
        if (this.pedido.beneficiario.politicamente_exposto) {
          return this.pedido.beneficiario.politicamente_exposto === PoliticamenteExposto.NaoPoliticamenteExposto ? 'Não' : 'Sim'
        }
        return '-'
      },
      sendAnalytics () {
        sendAnalyticsEvent(this.$gtag, 'menu_contrato', {
          numero_proposta: this.pedido.id_documento,
          valor_bem: this.pedido.bem.valor_bem,
          qtd_parcelas: this.pedido.plano.pz_restante,
          plano: this.pedido.plano.nome_plano,
          grupo: this.pedido.grupo.cd_grupo,
          nome_bem: this.pedido.bem.nome_bem,
          comissionado: this.nome_comissionado,
          filial: this.$session.get('filial')['NM_Filial_Venda'],
          cod_produto: this.pedido.produto.id_produto,
          genero: this.pedido.cliente.genero,
          data_nascimento: this.pedido.cliente.data_nascimento,
          renda: this.pedido.cliente.renda,
          cep: this.pedido.cliente.enderecos[0].cep,
          cidade: this.pedido.cliente.enderecos[0].cidade,
          source_menu: this.jornada_venda
        })
      },
      voltar () {
        if (this.pedido.id_reserva && this.pedido.reserva.completa) {
          this.$emit('prevPage')
        } else if (!isVendaNaoGerada(this.pedido.status_pedido)) {
          this.$router.back()
        } else {
          this.$emit('prevPage')
        }
      },
      trimZeros,
      async finalizar () {
        try {
          const res_venda = await this.realizarVenda(this.pedido.id_pedido, FormasPagamento.Boleto, null, true, false, false, this.pedido.cd_simulacao_ed)

          this.pedido.enviado = true

          const detalhes = res_venda.msg ? ('\n' + res_venda.msg) : ''

          this.$emit('finalizado')
          if (res_venda.data.enviado) {
            await asyncAlert(`Venda enviada com sucesso!${detalhes}`)
            const tela = 'selecionar_assinatura'
            const venda = res_venda.data
            this.$router.push({ name: 'contrato-venda', params: { venda, tela } })
          }
        } catch (err) {
          notification(AlertTypes.ERROR, err, err.message)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    label {
    font-size: 1rem;
    color: var(--darkgray);
}

p {
    color: var(--dark);
    font-size: 1.1rem;
}
</style>
